<template lang="pug">
div
  link(
    rel="stylesheet",
    href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"
  )
  link(
    rel="stylesheet",
    href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css"
  )
  v-app
    v-fade-transition(
          mode="out-in",
          v-if="(servicecode || routeplan || listing) && ready"
        )
      router-view(name="menu")
    v-fade-transition(
          mode="out-in",
          v-if="(servicecode || routeplan || listing) && ready"
        )
      router-view(name="navigation")
    v-main(app)
        v-fade-transition(
          mode="out-in",
          v-if="(servicecode || routeplan || listing) && ready"
        )
          router-view
        div(v-if="(!servicecode && !routeplan && !listing) || failed")
          h1 Incorrect embedding
</template>

<script>
import PowerTrip from "./services/api/PowerTrip.js";
import axios from "axios";
import Vue from "vue";
export default {
  props: ["servicecode", "routeplan"],
  data() {
    return {
      ready: false,
      failed: false,
      serviceID: this.servicecode,
      settings: this.$dealer.user_settings,
    };
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
  },
  async mounted() {
    this.Countly = this.$Countly;
    // Track sessions automatically (recommended)
    this.Countly.q.push(["track_sessions"]);

    // Track web page views automatically (recommended)
    this.Countly.q.push(["track_pageview"]);
    var existing = localStorage.getItem("token");
    console.log(existing);
    if (existing) {
      console.log("TOKEN");
      axios.defaults.headers.common["X-Auth-Powertrip"] = existing;
      var result = await PowerTrip.login();
      Vue.prototype.$user = result;
    }
    if (this.routeplan) {
      this.$router.push("planner");
      this.ready = true;
      this.$dealer.modelData = await PowerTrip.getEVModels();
      return;
    }
    if (this.listing) {
      this.$router.push("listing");
      this.ready = true;
      this.$dealer.modelData = await PowerTrip.getEVModels();
    }

    this.serviceID =
      (this.$route && this.$route.query.servicecode) ||
      localStorage.getItem("servicecode") ||
      this.servicecode;
    if (this.serviceID) {
      try {
        this.$dealer
          .init(this.serviceID, this.$vuetify, this.$Countly)
          .then((response) => {
            console.log(response);
            this.Countly.q.push([
              "add_event",
              {
                key: "Init",
                segmentation: {
                  dealer: this.$dealer.default_settings.name,
                },
              },
            ]);

            this.update();
            this.$bubble.location = this.$dealer.default_settings.addressData;
          });
      } catch (e) {
        console.log(e);
        this.failed = true;
      }
    }
  },
  methods: {
    update() {
      if (this.serviceID) {
        this.$dealer.updateTheme(this.$vuetify);
        this.ready = true;
      }
    },
  },
};
</script>
<style>
 [data-vuetify] header {
   min-height: 0;
 }
</style>
</style>
<style scoped lang="scss">
:where(power-sell) {
  all: initial;
  * {
    all: unset;
    margin: 0 auto;
    min-height: 0 !important;
  }
}

:where(*, *::before, *::after) {
  all: revert;
  box-sizing: border-box;
  max-width: 97vw;
  min-height: 0 !important;
}
header {
  min-height: 0;
}
.v-application--wrap {
  overflow: hidden;
  min-height: unset;
}

@import "../node_modules/leaflet/dist/leaflet.css";
@import "../node_modules/tiptap-vuetify/dist/main.css";
//@import "../node_modules/vuetify/dist/vuetify.min.css";
@import "../node_modules/vue-phone-number-input/dist/vue-phone-number-input.css";
</style>
<style>
.v-application--wrap {
  min-height: auto !important;
  overflow: hidden;
}
</style>
